"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _reselect = require('reselect');








var _common = require('shared/selectors/blobject/common');
var _team = require('shared/selectors/team');
var _peers = require('shared/selectors/peers');

var _utils = require('./utils');

const makeFallbackUserSubscriber = (UserKey) => ({ UserKey })
const makeFallbackTeamSubscriber = (TeamKey) => ({ TeamKey })
const makeFallbackPatientSubscriber = (PatientKey) => ({ PatientKey })



const populate = (
  { TeamSubscribers, UserSubscribers, PatientSubscribers },
  allTeams,
  allUsers,
  allPatients,
) => ({
  userSubscribersList: _utils.unsafePopulateSubscribers.call(void 0, _nullishCoalesce(UserSubscribers, () => ( {})), allUsers, makeFallbackUserSubscriber),
  teamSubscribersList: _utils.unsafePopulateSubscribers.call(void 0, _nullishCoalesce(TeamSubscribers, () => ( {})), allTeams, makeFallbackTeamSubscriber),
  patientSubscribersList: _utils.unsafePopulateSubscribers.call(void 0, _nullishCoalesce(PatientSubscribers, () => ( {})), allPatients, makeFallbackPatientSubscriber),
}) 

 const makeSelectUnsafePopulatedBlobjectSubscribers = () =>
  _reselect.createSelector.call(void 0, 
    _common.selectBlobjectByKey,
    _team.selectAllTeams,
    _peers.selectAllUsers,
    _peers.selectAllPatients,
    (blobject, allTeams, allUsers, allPatients) => blobject
      ? populate(blobject, allTeams, allUsers, allPatients)
      : _utils.EMPTY_SUBSCRIBERS_LIST,
  ); exports.makeSelectUnsafePopulatedBlobjectSubscribers = makeSelectUnsafePopulatedBlobjectSubscribers

/* The same for subscriber maps that aren't a chat in the store, such as a
 * search result's. */
 const makeSelectUnsafePopulatedSubscribers = () =>
  _reselect.createSelector.call(void 0, 
    (_state, subscribers) => subscribers,
    _team.selectAllTeams,
    _peers.selectAllUsers,
    _peers.selectAllPatients,
    populate,
  ); exports.makeSelectUnsafePopulatedSubscribers = makeSelectUnsafePopulatedSubscribers
